import React from "react";
import { LucideIcon, LayoutGrid, Calendar, Plus, CalendarDays, Scissors, Package, Users } from "lucide-react";
import QuickActionButton from "./QuickActionButton";

type QuickActionsPanelProps = {
  isClaimed: boolean;
  onAction: (action: string) => void;
};

type ActionConfig = {
  id: string;
  label: string;
  icon: LucideIcon;
  primary?: boolean;
};

const PRIMARY_ACTIONS: ActionConfig[] = [
  { id: "POS", label: "POS", icon: LayoutGrid, primary: true },
  { id: "Calendar", label: "Calendar", icon: Calendar, primary: true },
  { id: "Add Sale", label: "New Booking", icon: Plus, primary: true },
];

const SECONDARY_ACTIONS: ActionConfig[] = [
  { id: "Bookings", label: "Bookings", icon: CalendarDays },
  { id: "Services", label: "Services", icon: Scissors },
  { id: "Products", label: "Products", icon: Package },
  { id: "Employees", label: "Employees", icon: Users },
];

const QuickActionsPanel = ({ isClaimed, onAction }: QuickActionsPanelProps) => {
  const primary = PRIMARY_ACTIONS.filter((action) => {
    if (action.id === "POS" || action.id === "Calendar") return isClaimed;
    return true;
  });

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-[#402B69]">Quick Actions</h2>

      <div className="grid grid-cols-3 gap-3">
        {primary.map((action) => (
          <QuickActionButton
            key={action.id}
            icon={action.icon}
            label={action.label}
            onClick={() => onAction(action.id)}
            variant="primary"
          />
        ))}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {SECONDARY_ACTIONS.map((action) => (
          <QuickActionButton
            key={action.id}
            icon={action.icon}
            label={action.label}
            onClick={() => onAction(action.id)}
            variant="secondary"
          />
        ))}
      </div>
    </div>
  );
};

export default QuickActionsPanel;
